import {Injectable, OnDestroy} from '@angular/core';
import {AuthService} from '@app/core/services/auth.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {HttpService} from '@app/core/services/http.service';
import {IGroupFilter, GroupService as OldGroupService, IGroupsFilter} from '@app/modules/shared/services/group.service';
import {Group} from '@app/core/models/group.model';
import {Observable, Subscription} from 'rxjs';
import {PaginationHolder} from '@app/core/models/pagination.model';
import {map} from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class GroupService implements OnDestroy {

	public subscriptions: Subscription[] = [];

	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		private oldGroupService: OldGroupService,
	) {
	}

	public getGroups(filters: IGroupsFilter = {}, page_size: number = 200, page: number = 1): Observable<Group[]> {
		const data = {
			...filters,
			page_size,
			page,
		};

		return this.httpService.getJson<PaginationHolder<Group>>('groups', data)
			.pipe(map((res) => res.data.map(g => this.oldGroupService.fresh(g))));
	}

	public getGroup(id: string, filters: IGroupFilter = {}): Observable<Group> {
		const data = {
			...filters,
		};

		return this.httpService.getJson<Group>('groups/' + id, data)
			.pipe(map((res) => this.oldGroupService.fresh(res)));
	}

	public postGroup(payload: {}): Observable<{ success: boolean, error: {} }> {
		return this.httpService.postJson<{ success: boolean, error: any }>('groups', payload);
	}

	public patchGroup(groupId: number | string, payload: {}): Observable<{ success: boolean, error: any }> {
		return this.httpService.patchJson<{ success: boolean, error: any }>('groups/' + groupId, payload);
	}

	public deleteGroup(id: number | string): Observable<{ success: boolean, error: any }> {
		return this.httpService.deleteJson<{ success: boolean, error: any }>('groups/' + id);
	}

	public ngOnDestroy(): void {
		this.subscriptions.forEach(s => s.unsubscribe());
	}
}
